module.exports = __webpack_public_path__ + "2d36b17d84a63dd1d7c4ec19ee7c0015.svg";